module.exports = __webpack_public_path__ + "static/media/n1.5d29e57a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/n1.png
// module id = 1330
// module chunks = 1